import * as Yup from 'yup';

import {
  UPPERCASE_REG_EX,
  NUMERIC_REG_EX,
  EMAIL_REG_EX,
  LOWERCASE_REG_EX,
  SPECIAL_CHARACTER_REG_EX,
} from '../utils/regex';
import {
  INSTANCE_PHONE_REG_EX,
  INSTANCE_PHONE_MIN_LENGTH,
} from '../utils/instanceConstant';
export const addNewUserByAdminInitialValues = () => {
  return {
    organisationId: '',
    firstName: '',
    surname: '',
    email: '',
    password: '',
    confirmPassword: '',
    positionTitle: '',
    phone: '',
    isTaksoAdminEmail: false,
  };
};

export const addNewUserByAdminValidationSchema = (
  t,
  isTaksoAdminUser = false
) => {
  let validationSchema = {
    organisationId: Yup.string().required(
      t('formulary.validation.organisation_id_required')
    ),
    firstName: Yup.string().required(
      t('formulary.validation.first_name_required')
    ),
    surname: Yup.string().required(t('formulary.validation.surname_required')),
    phone: Yup.string()
      .required(t('formulary.validation.phone_number_required'))
      .matches(
        INSTANCE_PHONE_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      )
      .min(
        INSTANCE_PHONE_MIN_LENGTH,
        t('formulary.validation.must_be_a_minimum_of_digits', {
          count: INSTANCE_PHONE_MIN_LENGTH,
        })
      ),
    email: Yup.string()
      .required(t('formulary.validation.email_required'))
      .matches(
        EMAIL_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      ),

    positionTitle: Yup.string().optional(),
  };

  if (isTaksoAdminUser) {
    validationSchema = {
      ...validationSchema,
      password: Yup.string()
        .min(8, 'LENGTH_ERROR')
        .required('LENGTH_ERROR')
        .matches(LOWERCASE_REG_EX, 'LOWERCASE_ERROR')
        .matches(UPPERCASE_REG_EX, 'UPPERCASE_ERROR')
        .matches(NUMERIC_REG_EX, 'NUMERIC_ERROR')
        .matches(SPECIAL_CHARACTER_REG_EX, 'SPECIAL_CHARACTER_ERROR'),
      confirmPassword: Yup.string()
        .required(t('formulary.validation.confirm_password_required'))
        .oneOf(
          [Yup.ref('password'), null],
          t('formulary.validation.doesnt_match_the_new_password')
        ),
    };
  }

  return Yup.object().shape(validationSchema);
};
